import { useSettings } from "@/context/SettingsContext";

export const FloatingWhatsApp = () => {
  const settings = useSettings();
  return (
    <a
      href={`https://wa.me/${settings.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform z-50 flex items-center justify-center"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
        <path d="M16.003 3C9.38 3 4 8.38 4 15c0 2.114.553 4.176 1.602 5.994L4 29l8.2-2.15A11.93 11.93 0 0016 27c6.62 0 12-5.38 12-12S22.62 3 16.003 3zm0 21.82c-1.86 0-3.68-.5-5.27-1.45l-.38-.22-4.87 1.28 1.3-4.75-.25-.39A9.78 9.78 0 016.18 15c0-5.42 4.41-9.82 9.82-9.82 5.42 0 9.82 4.4 9.82 9.82s-4.4 9.82-9.82 9.82zm5.39-7.35c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.05 1.02-1.05 2.49s1.07 2.89 1.22 3.09c.15.2 2.11 3.22 5.11 4.51.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.08 1.76-.72 2-1.41.25-.69.25-1.28.17-1.41-.07-.13-.27-.2-.57-.35z" />
      </svg>
    </a>
  );
};

export default FloatingWhatsApp;
